<template>
    <gofix-card :title="title" classHeader="mb-13" classContent="mb-0" class="position-relative">
        <p>{{ desc }}</p>
        <template  v-if="isShowChecklistChild">
            <div class="position-absolute" style="right: 50px; top: 8.5px; font-size: 16px;">
                <gofix-button
                    v-if="this.$checkRole(this.$accessModule.permit_to_work, 'update') && tableItems.length"
                    :disabled="isDisabledSave"
                    :loading="loadingSave"
                    @click="updateData"
                    label="SAVE">
                </gofix-button>
            </div>
            <b-row no-gutters>
                <template v-for="(item, index) in tableItems">
                    <b-col md="12" class="mb-13" :key="index" v-if="item.children.length == 0">
                        <checklist-entries :job="job" :section="item.name" @updateCheckListEntries="updateCheckListEntries" @reloadChecklist="reloadChecklist" @inputType="isTyping = true" :item="item" typeJob="PTW"></checklist-entries>
                    </b-col>
                    <template v-else>
                        <template v-for="(item1) in item.children">
                        <b-col md="12" class="mb-13" :key="item1.id">
                            <checklist-entries :job="job" :section="item.name + ' >> ' + item1.name" @updateCheckListEntries="updateCheckListEntries" @reloadChecklist="reloadChecklist" @inputType="isTyping = true" :item="item1" typeJob="PTW"></checklist-entries>
                        </b-col>
                        </template>
                    </template>
                </template>
            </b-row>
        </template>
        
        <b-row no-gutters class="mb-15" v-if="signatures">
            <b-col md="12">
                <gofix-text-field label="Geo Fencing" oneline>
                    <b-button class="ml-2 p-0 bg-transparent border-0 goFixLocationButton" title="Geo Coordinates" v-b-tooltip.hover @click="showGeoLocation">
                        <i class="icon-location-pin color-orange font-weight-bolder"></i>
                    </b-button>
                </gofix-text-field>
            </b-col>
            <b-col md="12" class="mt-3" v-if="typeComment && typeComment == 'comment_sa'">
                <h5 class="mb-3">
                    <span v-if="isAllowEditComment" style="" @click="showModalComment" class="mr-2 mb-2 cursor-pointer">
                        <img src="img/iconPencil.png" alt="edit-comment" with="18px" height="18">
                    </span>
                    Safety Assessor Remark(s)
                </h5>
            </b-col>
            <b-col md="12" class="mb-3 d-flex align-items-center">
                <span v-if="isAllowEditComment && typeComment != 'comment_sa'" style="" @click="showModalComment" class="mr-2 mb-2 cursor-pointer">
                    <img src="img/iconPencil.png" alt="edit-comment" with="18px" height="18">
                </span>
                <gofix-text-field label="Comment" oneline>
                    {{ job && typeComment && job[typeComment] ? job[typeComment].description : '-' }}
                </gofix-text-field>
            </b-col>
            <b-col md="12" v-if="typeComment && typeComment == 'comment_sa' && job && job[typeComment] && job[typeComment].attachments">
                <div class="photosThumb photosThumb-safety mt-0 mb-0">
                    <viewer-image :images="job[typeComment].attachments">
                        <template slot="gofixViewer:list_image">
                            <ul class="list-thumb mb-2">
                                <template v-for="(item, key) in job[typeComment].attachments">
                                    <li :key="key">
                                        <img v-auth-image="item.url.medium" alt  src="img/loading.gif"/>
                                        <span class="delete" @click.stop="deletePhotoInComment(item)" v-if="isAllowEditComment">
                                            <img src="img/close.png" alt />
                                        </span>
                                    </li>
                                </template>
                            </ul>
                        </template>
                    </viewer-image>
                </div>
            </b-col>
            <b-col md="12">
                <b-table :fields="fields" :items="signatures" bordered fixed class="mb-0">
                    <template slot="user" slot-scope="row">
                        {{row.item.user && row.item.user.name ? row.item.user.name : '-' }}
                        <gofix-text-field label=" " class="photosThumb mt-2">
                            <template v-if="row.item.photos">
                                <viewer-image :images="row.item.photos">
                                    <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                        <div v-for="(item_image, key) in images">
                                            <img v-auth-image="item_image.url.original" :alt="item_image.image_file_name" :key="item_image.url.original" src="img/loading.gif" width="200" class="mr-2">
                                        </div>
                                    </template>
                                </viewer-image>
                            </template>
                        </gofix-text-field>
                    </template>
                    <template slot="created_at" slot-scope="row">
                        {{row.item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                    </template>
                    <template slot="actual_created_at" slot-scope="row">
                        {{row.item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                    </template>
                    <template slot="signature" slot-scope="row">
                        <b-row>
                            <b-col md="6">
                                <gofix-text-field label=" " class="photosThumb mt-0" classInner="justify-content-end" oneline>
                                    <template v-if="row.item.attachments">
                                        <viewer-image :images="row.item.attachments" classViewer='d-flex align-items-center'>
                                            <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                <ul class="list-thumb signature_v2">
                                                    <template v-for="(item_image, key) in images">
                                                        <li :key="key">
                                                            <img v-auth-image="item_image.url.original" :alt="item_image.image_file_name" :key="item_image.url.original" src="img/loading.gif">
                                                        </li>
                                                    </template>
                                                </ul>
                                            </template>
                                        </viewer-image>
                                    </template>
                                </gofix-text-field>
                            </b-col>
                        </b-row>
                    </template>
                </b-table>
            </b-col>

            <b-modal :title="typeComment != 'comment_sa' ? 'Comment' : 'Safety Assessor Remark(s)'" :no-close-on-backdrop="true" body-class="px-0" id="modal-Check-FollowUp" hide-footer :centered="true" v-model="modal.comment.open">
                <div class="pl-20 pr-20">
                    <b-form-group label="Comment" class="clear-both text-remark notFloat">
                        <b-form-textarea v-model="modal.comment.data.description" class="notFloat" rows="4"></b-form-textarea>
                    </b-form-group>
                    <b-form-group label="photos" class="photosThumb clear-both" v-if="typeComment == 'comment_sa'">
                        <ul class="list-thumb">
                            <li v-for="(item,key) in modal.comment.data.photos" v-bind:key="key">
                                <img v-auth-image="item.url.thumb" src="img/loading.gif" :alt="item.image_file_name || 'image'" />
                                <span class="delete" @click.stop="deletePhotoInModal(item)">
                                    <img src="img/close.png" alt />
                                </span>
                            </li>
                        </ul>
                        <div class="upload-btn-wrapper">
                            <b-form-file id="fileInputMulti" v-model="modal.comment.photos.in_local" :plain="true" :multiple="true"></b-form-file>
                            <gofix-button class="m-3" label="add photo" outline></gofix-button>
                        </div>
                    </b-form-group>
                </div>
                <b-button-group class="d-block text-right pl-10 pr-10">
                    <gofix-button :loading="modal.comment.loading" label="APPLY" @click="saveComment" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
        </b-row>
    </gofix-card>
</div>
</template>

<script>
    const ViewerImage = () => import('@/views/plugins/ViewerImage.vue')
    const checklistEntries = () => import("../detail-checklist")
    import moment from 'moment';
    export default {
        name: 'detail-signature',
        components: {
            ViewerImage,
            checklistEntries
        },
        props: {
            signatures: {
                type: Array,
                default: () => []
            },
            title: {
                type: String,
                default: ''
            },
            desc: {
                type: String,
                default: ''
            },
            job: {
                type: Object,
                default: () => {}
            },
            typeComment: {
                type: String,
                default: null
            },
            isShowChecklistChild: {
                type: Boolean,
                default: false
            },
            onClickShowGeo: {
                type: Function,
            }
        },
        data() {
            return {
                fields: [
                    {
                        key: 'user',
                        label: 'By',
                        thStyle: 'width: 200px'
                    },
                    {
                        key: 'created_at',
                        label: 'Submit Date / Time',
                        thStyle: 'width: 150px'
                    },
                    {
                        key: 'actual_created_at',
                        label: 'Actual Submit Date / Time',
                        thStyle: 'width: 150px'
                    },
                    {
                        key: 'signature',
                        label: 'Signature',
                        thStyle: 'width: 150px'
                    },
                ],
                modal: {
                    comment: {
                        open: false,
                        loading: false,
                        data: {
                            description: '',
                            photos: [],
                        },
                        photos: {
                            in_local: null,
                            in_push: [],
                            del_ids: []
                        }
                    }
                },
                tableItems: [],
                checkListEntryUpdate: [],
                loadingCheckListEntry: false,
                isTyping: false,
                isSave: false,
                loadingSave: false,
            }
        },
        watch: {
            job: function(val, old){
                if(this.isShowChecklistChild && val && (!old || old && val.id != old.id)) {
                    this.getCheckListGroupData();
                }
            },
            isTyping: function(val) {
                if(val === false && this.isSave === true) {
                    this.updateData();
                }
            },
            'modal.comment.photos.in_local'(val, old) {
                if (val) {
                    val.forEach((file) => {
                        if (
                            file.type != "image/jpeg" &&
                            file.type != "image/png" &&
                            file.type != "image/gif"
                        ) {
                            this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                            return;
                        }
                        file.moment = moment().valueOf();
                        let data = {
                            moment: moment().valueOf(),
                            url: {
                                original: URL.createObjectURL(file),
                                medium: URL.createObjectURL(file),
                                thumb: URL.createObjectURL(file),
                            },
                        };
                        this.modal.comment.photos.in_push.push(file);
                        this.modal.comment.data.photos.push(data);
                    });
                }
            },
        },
        computed: {
            isAllowEditComment() {
                return this.$checkRole(this.$accessModule.permit_to_work, 'update') && 
                    (this.job && this.job.planned_date && new Date(this.job.planned_date).toDateString() === new Date().toDateString()) && 
                    (this.typeComment == 'comment_cs' || (this.typeComment != 'comment_cs' &&  this.job && this.job.related_id))
            },
            isDisabledSave() {
                return this.job && ((this.job.related_id && this.job.status != 'Submitted') || (this.job.planned_date && new Date(this.job.planned_date).toDateString() !== new Date().toDateString()));
            },
        },
        created() {
            if(this.isShowChecklistChild){
                this.getCheckListGroupData();
            }
        },
        methods: {
            showModalComment() {
                this.modal.comment.data.description = this.job && this.typeComment && this.job[this.typeComment] ? this.job[this.typeComment].description : '';
                this.modal.comment.data.photos = this.job && this.typeComment && this.job[this.typeComment] && this.job[this.typeComment].attachments ? JSON.parse(JSON.stringify(this.job[this.typeComment].attachments)) : [];
                this.modal.comment.photos.del_ids  = []
                this.modal.comment.photos.in_push  = []
                this.modal.comment.photos.in_local = null
                this.modal.comment.open = true;
            },
            saveComment() {
                this.$store.dispatch("SafetyAppController/saveCommentPTW", {
                    id: this.job.id,
                    data: {
                        description: this.modal.comment.data.description,
                        type: this.typeComment
                    },
                    photos: this.modal.comment.photos.in_push
                }).then(() => {
                    if(this.modal.comment.photos.del_ids.length) {
                        this.deletePhoto(this.modal.comment.photos.del_ids)
                        return;
                    }
                    this.$emit('reloadItem', this.job.id);
                }).catch(() => {}).finally(() => {
                    this.modal.comment.open = false;
                });
            },
            async getCheckListGroupData(){
                if(!this.job || !this.job.id || (this.job && (!this.job.related_id))) {
                    this.tableItems = [];
                    return;
                }
                this.loadingCheckListEntry = true;
                await this.$store
                    .dispatch("SafetyAppController/getSafetyCheckListGroupData", this.job.id)
                    .then((result) => {
                        this.tableItems = result.items;
                        this.loadingCheckListEntry = false;
                        this.$emit('loadChecklistEntriesOfJobChild', this.tableItems)
                    })
                    .catch((err) => {
                        this.loadingCheckListEntry = false;
                });
            },
            reloadChecklist() {
                this.getCheckListGroupData();
            },
            async updateCheckListEntries(val){
                let params = val;
                let request = {
                    id: params.val.id,
                    value: params.val.input.value,
                    status: params.val.status,
                }
                if(params.val.hasOwnProperty('output')) request.output = params.val.output;
                if(params.val.hasOwnProperty('is_output_highlighted')) request.is_output_highlighted = params.val.is_output_highlighted;
                if(!params.from_status){
                    if(params.val.input.value){ request.status = params.val.status = 'Filled'; }
                    else{ request.status = params.val.status = 'Unfilled';}
                }

                let checkListEntryData = [request];
                if(this.checkListEntryUpdate.length > 0){
                    checkListEntryData = Object.assign([], this.checkListEntryUpdate);
                }
                let flag = false;
                if(checkListEntryData.length > 0){
                    for (let i = 0; i < checkListEntryData.length; i++) {
                        if (request && request.id == checkListEntryData[i].id) {
                            this.checkListEntryUpdate[i] = request;
                            flag = true;
                            break;
                        }
                    }
                    if(!flag){
                        this.checkListEntryUpdate.push(request);
                    }
                }
                this.isTyping = false;
                this.$emit('changeChecklistEntry', this.checkListEntryUpdate.length)
            },
            updateData() {
                if (this.timer_save) {
                    clearTimeout(this.timer_save);
                    this.timer_save = null;
                }
                this.timer_save = setTimeout(() => {
                    if(this.isTyping) {
                        this.isSave = true;
                        return;
                    }
                    this.isSave = false;

                    var checkValidate = this.checkListEntryUpdate.filter(function(item) {
                        return (item.status === 'Filled' && !item.value);
                    });
                    if(checkValidate.length > 0){
                        return this.$alertNotification("Please enter checklist entries value when the status Filled", "danger");
                    }
                    this.loadingSave = true;
                    let request = {
                        array_data: JSON.stringify(this.checkListEntryUpdate),
                        job_id: this.job.id
                    };
                    this.$store
                        .dispatch("SafetyAppController/updateCheckListJob", request)
                        .then(async (data) => {
                            // await this.getItem();
                            this.loadingSave = await false;
                            this.checkListEntryUpdate = [];
                            this.$emit('changeChecklistEntry', 0)
                            this.$alertNotification(this.$notificationV2("editing", "checklist"));
                        })
                        .catch((err) => {
                            this.$alertNotification("Can not update checklist!", "danger");
                        });
                }, 100);
            },
            deletePhotoInComment(img) {
                if (img.moment) {
                    this.modal.comment.data.photos = this.modal.comment.data.photos.filter(
                        (item) => item.moment != img.moment
                    );
                    this.modal.comment.photos.in_push = this.modal.comment.photos.in_push.filter(
                        (item) => item.moment != img.moment
                    );
                } else {
                    this.modal.comment.data.photos = this.modal.comment.data.photos.filter(
                        (item) => item.id != img.id
                    );
                    this.deletePhoto([img.id])
                }
            },
            deletePhotoInModal(img) {
                if (img.moment) {
                    this.modal.comment.data.photos = this.modal.comment.data.photos.filter(
                        (item) => item.moment != img.moment
                    );
                    this.modal.comment.photos.in_push = this.modal.comment.photos.in_push.filter(
                        (item) => item.moment != img.moment
                    );
                } else {
                    this.modal.comment.data.photos = this.modal.comment.data.photos.filter(
                        (item) => item.id != img.id
                    );
                    this.modal.comment.photos.del_ids.push(img.id);
                }
            },
            deletePhoto(imgs = []) {
                this.$store.dispatch("SafetyAppController/deleteAttachments", {
                    ids: imgs
                }).then((result) => {
                    this.$emit('reloadItem', this.job.id);
                })
            },
            showGeoLocation() {
                let type = this.typeComment == 'comment_sa' ? 'Pending Approval' : 'Approved';
                this.onClickShowGeo(this.job.id, type);
            }
        }
    }
</script>
